import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import SendMessagePage from "@/pages/SendMessagePage.vue";
import UploadImage from "@/pages/UploadImage.vue";
import ShowListRegisterService from "@/pages/ShowListRegisterService.vue";
import UpdateRegisterService from "@/pages/UpdateRegisterService.vue";
import RegisterUserPage from "@/pages/RegisterUserPage.vue";
import AddEmployeePage from "@/pages/AddEmployeePage.vue";
import showListEmployee from "@/pages/ShowListEmployee.vue";
import updateEmployeePage from "@/pages/UpdateEmployeePage.vue";
import addGroupAndMemberPage from "@/pages/AddGroupAndMemberPage.vue";
import addReceiverReportPage from "@/pages/AddReceiverReportPage.vue";
import ManagerGroupPage from "@/pages/ManagerGroupPage.vue";
import ShowListDayOff from "@/pages/ShowListDayOff.vue";
import addManagerCheckinPage from "@/pages/AddManagerCheckinPage.vue";
import showListCheckIn from "@/pages/ShowListCheckIn.vue";
import carPage from "@/pages/CarPage.vue";
import addManagerBookingPage from "@/pages/AddManagerBookingPage.vue";
import addEmployeeCheckinPage from "@/pages/AddEmployeeCheckinPage.vue";
import sendFile from "@/pages/SendFile.vue";
import userList from "@/pages/UserList.vue";
import addImagePatient from "@/pages/AddImagePatient.vue";
import addReceiverStatisticalPage from "@/pages/AddReceiverStatisticalPage.vue";
import reLoginPage from "@/pages/ReLoginPage.vue";
import searchParaclinical from "@/pages/SearchParaclinical.vue";
import resultNotificationPage from "@/pages/resultNotificationPage.vue";
import addBooking from "@/pages/AddBooking.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '',
    component: Home,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/sendFile',
    name: 'sendFile',
    component: sendFile,
    props: true
  },
  {
    path: '/relogin',
    name: 'reLoginPage',
    component: reLoginPage,
    props: true
  },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: RegisterPage,
  //   props: true
  // },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/addemployee',
    name: 'addemployee',
    component: AddEmployeePage,
    props: true
  },
  {
    path: '/addReceiverReportPage',
    name: 'addReceiverReportPage',
    component: addReceiverReportPage,
    props: true
  },
  {
    path: '/registeruser',
    name: 'registeruser',
    component: RegisterUserPage,
    props: true
  },
  {
    path: '/sendmessage',
    name: 'sendmessage',
    component: SendMessagePage,
    props: true
  },
  {
    path: '/uploadImage',
    name: 'uploadImage',
    component: UploadImage,
    props: true
  },
  {
    path: '/listRegisterService',
    name: 'listRegisterService',
    component: ShowListRegisterService,
    props: true
  },
  {
    path: '/updateregisterservice/:id',
    name: 'updateregisterservice',
    component: UpdateRegisterService,
    props: true
  },
  {
    path: '/showlistemployee',
    name: 'showlistemployee',
    component: showListEmployee,
    props: true
  },
  {
    path: '/addGroup',
    name: 'addGroup',
    component: addGroupAndMemberPage,
    props: true
  },
  {
    path: '/updateemployee/:id',
    name: 'updateemployee',
    component: updateEmployeePage,
    props: true
  },
  {
    path: '/managerGroup',
    name: 'managerGroup',
    component: ManagerGroupPage,
    props: true,
  },
  {
    path: '/ShowListDayOff',
    name: 'ShowListDayOff',
    component: ShowListDayOff,
    props: true,
  },
  {
    path: '/addManagerCheckinPage',
    name: 'addManagerCheckinPage',
    component: addManagerCheckinPage,
    props: true
  },
  {
    path: '/addManagerBookingPage',
    name: 'addManagerBookingPage',
    component: addManagerBookingPage,
    props: true
  },
  {
    path: '/showListCheckIn',
    name: 'showListCheckIn',
    component: showListCheckIn,
    props: true
  },
  {
    path: '/addEmployeeCheckinPage',
    name: 'addEmployeeCheckinPage',
    component: addEmployeeCheckinPage,
    props: true
  },
  {
    path: '/carPage',
    name: 'carPage',
    component: carPage,
    props: true
  },
  {
    path: '/userList',
    name: 'userList',
    component: userList,
    props: true
  },
  {
    path: '/addImagePatient',
    name: 'addImagePatient',
    component: addImagePatient,
    props: true
  },
  {
    path: '/addReceiverStatisticalPage',
    name: 'addReceiverStatisticalPage',
    component: addReceiverStatisticalPage,
    props: true
  },
  {
    path: '/resultNotificationPage',
    name: 'resultNotificationPage',
    component: resultNotificationPage,
    props: true
  },
  {
    path: '/searchParaclinical',
    name: 'searchParaclinical',
    component: searchParaclinical,
    props: true
  },
  {
    path: '/addBooking',
    name: 'addBooking',
    component: addBooking,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
